// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportSectionEntity from './entities/report-section.json';
import reportSectionMenu from '../pages/report-section/menu.json';
import reportSectionFullForm from '../pages/report-section/forms/full.json';
import reportSectionContextForm from '../pages/report-section/forms/context.json';
import reportSectionMiniForm from '../pages/report-section/forms/mini.json';
import reportSectionLookupForm from '../pages/report-section/forms/lookup.json';
import reportSectionTableView from '../pages/report-section/views/table.json';
import reportSectionCardsView from '../pages/report-section/views/cards.json';
import reportSectionDashboardView from '../pages/report-section/views/dashboard.json';

/** Тип запису «Розділ звіту» зі сторінками пакета: меню, форми та подання з pages/report-section/. */
export const reportSectionDefinition: IRecordTypeDefinition = {
  ...reportSectionEntity,
  views: assembleViewSet({
      table: reportSectionTableView,
      cards: reportSectionCardsView,
      dashboard: reportSectionDashboardView,
  }),
  form: reportSectionFullForm,
  forms: { full: reportSectionFullForm, context: reportSectionContextForm, mini: reportSectionMiniForm, lookup: reportSectionLookupForm },
  menu: reportSectionMenu,
} as IRecordTypeDefinition;
